var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.221558,
    width: 35,
    height: 35,
    fill: "url(#pattern0_698_232)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_698_232",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_698_232",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_698_232",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAAA3pJREFUeAHtnUGKU0EYhKOCHsKFG/EUXkBc5xQaofvvA2TrXbyDO6Mb4xnUlSuH0fXok4SCQE0ivFR3pv6BIf/8hFd/ffX6JS8D6cUif5JAEkgCSSAJJIEkkASSQBJIAoMQWK1Wj1prb0opH2utvyLiZo7fWuvP1tq7WuuzQayOP0Yp5XFEfJkjgFuOcRURz8en0XnCaWUIwvi32lprPyLiSWfLY8tPl6lbzupZLlsHx98sl8sHY1PpOF1EfDoAdo4QDo9ZOloeWzoirtWB1Fp/l1Kejk2m03TqMPZ6pZT36/X6fifb48ruAXV6fLtYLO6NS6fDZJ2COHxNuXN/T/dy0z1da+31er1+eHK0Gcg8N8BHOG6ne72TQjlyoDt35nb0+/mkldJxQLuwa62vjq6SDERyydqffJsMZKYPSWc6ca8zkLECuclAMhDpNXl/bb6Yx1whl7ZCjiaWT0gCSSAJJIEkQAi01l5GxPeZbnwu5t2O2m8p5dvf/86+IDGgvXtigtS8G/sK8qRSnynueiQGtN0Bqf2DPKnUA7nrkRjQdgek9g/ypFIP5K5HYkDbHZDaP8iTSj2Qux6JAW13QGr/IE8q9UDueiQGtN0Bqf2DPKnUA7nrkRjQdgek9g/ypFIP5K5HYkDbHZDaP8iTSj2Qux6JAW13QGr/IE8q9UDueiQGtN0Bqf2DPKnUA7nrkRjQdgek9g/ypFIP5K5HYkDbHZDaP8iTSj2Qux6JAW13QGr/IE8q9UDueiQGtN0Bqf2DPKnUA7nrkRjQdgek9g/ypFIP5K5HYkDbHZDaP8iTSj2Qux6JAW13QGr/IE8q9UDueiQGtN0Bqf2DPKnUA7nrkRjQdgek9g/ypFIP5K5HYkDbHZDaP8iTSj2Qux6JAW13QGr/IE8q9UDueiQGtN0Bqf2DPKnUA7nrkRjQdgek9g/ypFIP5K5HYkDbHZDaP8iTSj2Qux6JAW13QGr/IE8q9UDueiQGtN0Bqf2DPKnUA7nrkRjQdgek9g/ypFIP5K5HYkDbHZDaP8iTqsfGkmoIA+ldkRjQ7rT1quv3BJ+05dFqoDPoTgc17WmIpUCq3fbd2wzl7BvRbE/aNm/KabfBfYZyvq8bP31jyf3CmdKbllREbPKFfpbVMu3C/eG/t17dB5KPSSAJJIEkkASSQBJIAkkgCSSBMxH4A0+koBuNfTJdAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderAttachment);
export default __webpack_public_path__ + "static/media/folderAttachment.a6f3f39b257953de92fbdc37b01c8b61.svg";
export { ForwardRef as ReactComponent };